import instanceQuery from 'graphql/queries/supplier/PurchasePaymentPostingPreviewQuery.graphql';
import fragment from 'graphql/fragments/nominal/NominalPostingPreviewFragment.graphql';
import { EntityType } from '../../../@types/entityTypes';

const PurchasePaymentPostingPreview: EntityType = {
  type: 'PostingResponse',
  formTitle: 'Nominal Posting Preview',
  instance: instanceQuery,
  fragment,
};

export default PurchasePaymentPostingPreview;
